import { SectionHeading } from './SectionHeading'

const ITEMS = [
  {
    label: '募集職種',
    value: 'プログラマー（JavaScript / C# / Java / PHP 等）'
  },
  { label: '勤務地', value: '東京都新宿区高田馬場' },
  { label: '勤務時間', value: '平日 9:00〜18:00（土日祝・年末年始除く）' },
  { label: '雇用形態', value: '正社員 / 契約社員 / 業務委託' },
  { label: 'リモート', value: '週の半分以上可能' }
]

export function Recruitment() {
  return (
    <section
      id="recruitment"
      className="section-wrapper relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white via-slate-50 to-blue-50/30" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="We Are Hiring" title="技術者募集" />

        <div className="max-w-3xl mx-auto">
          <dl className="animate-on-scroll bg-white border border-slate-100 rounded-2xl shadow-sm overflow-hidden">
            {ITEMS.map((item, i) => (
              <div
                key={item.label}
                className={`flex flex-col sm:flex-row gap-2 sm:gap-0 px-8 py-5 ${
                  i < ITEMS.length - 1 ? 'border-b border-slate-100' : ''
                }`}
              >
                <dt className="w-full sm:w-36 text-brand-blue text-sm font-semibold shrink-0">
                  {item.label}
                </dt>
                <dd className="text-brand-navy/80 text-sm">{item.value}</dd>
              </div>
            ))}
          </dl>

          <div className="mt-8 text-center animate-on-scroll animate-on-scroll-delay-1">
            <p className="text-brand-navy/50 text-sm mb-6">
              詳細・ご応募はお問い合わせボタンよりご連絡ください。
            </p>
            <a href="#contact" className="btn-primary">
              お問い合わせ・応募はこちら
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
